<template>
	<div class="toggle" @click="toggle">
		<svg v-if="soundsStatus" class="active" viewBox="0 0 24 24">
			<path fill="#2475f4" d="M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z" />
		</svg>
		<svg v-else class="disabled" viewBox="0 0 24 24">
			<path fill="#2475f4" d="M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z" />
		</svg>
	</div>
</template>

<script>
export default {
	methods: {
		toggle() {
			if (this.$router.history.current.name == "Intro") {
				setTimeout(() => {
					this.playAudio("intro", true);
				}, 100);
			}

			let soundsStatus = !this.$store.state.soundsStatus;
			this.updateProperty({
				property: "soundsStatus",
				value: soundsStatus,
			});

			if (soundsStatus) {
				for (let sound in this.$store.state.sounds) {
					this.$store.state.sounds[sound].volume = 1;
				}
				/* switch(this.$router.history.current.path) {

					case '/':
						this.playAudio('intro',true);
					break;

					case '/game':
						if(!this.$store.state.endRound && !this.$store.state.endGame) {
							this.playAudio('soundtrack',true);
						}
					break;
				} */
			} else {
				for (let sound in this.$store.state.sounds) {
					/* this.$store.state.sounds[sound].pause();
					this.$store.state.sounds[sound].currentTime = 0;
					this.$store.state.sounds[sound].playbackRate = 1; */
					this.$store.state.sounds[sound].volume = 0;
				}
			}
		},
	},
	mounted() {
		for (let sound in this.$store.state.sounds) {
			/* this.$store.state.sounds[sound].pause();
			this.$store.state.sounds[sound].currentTime = 0;
			this.$store.state.sounds[sound].playbackRate = 1; */
			this.$store.state.sounds[sound].volume = 0;
		}

		this.status = false;
	},
};
</script>
<style scoped lang="scss">
.toggle {
	position: fixed;
	bottom: px(20);
	right: px(20);
	border-radius: 100%;
	padding: px(30);
	z-index: 999999;
	display: inline-block;
	cursor: pointer;
	background: $mondadori-yellow;

	@include breakpoint(m) {
		display: none;
	}

	svg {
		display: inline-block;
		position: absolute;
		width: px(24);
		height: px(24);
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}
</style>
